import * as React from 'react';
import PublishPbpFull from './view/PublishPbpFull';
import { isFeatureEnabled } from 'owa-feature-flags';
import { Option } from 'owa-options-core';

let PublishPbpOption: Option = {
    key: 'publishPbpOption',
    titleStringKey: 'optionTitle_pbpPublishingOptions',
    searchTermsStringKey: 'optionTitle_pbp',
    fullOptionFormSettings: {
        render: () => <PublishPbpFull />,
        isDirty: () => false,
        onSave: null,
        onDiscard: null,
        hideSaveDiscard: () => true,
    },
    isHidden: () => {
        return !isFeatureEnabled('cal-pbp-option');
    },
};

export default PublishPbpOption;
